module.exports = __webpack_public_path__ + "static/media/logo19.3a13106d.png";